import { createSelector } from "reselect";
import {
  FETCHED_CLIENT_TOKEN,
  FETCHED_PAYMENT_METHODS,
  DONE_BRAINTREE_PAYMENT,
  SET_ERROR_ADD_PAYMENT_METHOD,
  CLEAR_ERROR_ADD_PAYMENT_METHOD,
} from "./braintree.actions";
import { CLEAR_PAYMENTS } from "../payment.actions";

const INITIAL_STATE = {
  clientToken: null,
  paymentMethods: null,
  paymentResult: null,
  paymentError: null,
  errorAddPaymentMethod: null,
};

export default function braintree(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case FETCHED_CLIENT_TOKEN: {
      return {
        ...state,
        clientToken: action.clientToken,
      };
    }
    case FETCHED_PAYMENT_METHODS: {
      return {
        ...state,
        paymentMethods: action.paymentMethods,
      };
    }
    case DONE_BRAINTREE_PAYMENT: {
      return {
        ...state,
        paymentResult: action.data.data,
        errorAddPaymentMethod: null,
      };
    }
    case SET_ERROR_ADD_PAYMENT_METHOD: {
      return {
        ...state,
        errorAddPaymentMethod: action.err,
      };
    }
    case CLEAR_ERROR_ADD_PAYMENT_METHOD: {
      return {
        ...state,
        errorAddPaymentMethod: null,
      };
    }
    case CLEAR_PAYMENTS: {
      return {
        ...state,
        paymentResult: INITIAL_STATE.paymentResult,
        paymentError: INITIAL_STATE.paymentError,
      };
    }
    default: {
      return state;
    }
  }
}

const selectPaymentState = (state) => state.payment.braintree;

export const selectClientToken = createSelector(
  selectPaymentState,
  (state) => state.clientToken
);

export const selectPaymentMethos = createSelector(
  selectPaymentState,
  (state) => state.paymentMethods
);

export const selectBraintreeResult = createSelector(
  selectPaymentState,
  (state) => state.paymentResult
);

export const selectBraintreeError = createSelector(
  selectPaymentState,
  (state) => state.paymentError
);

export const selectErrorAddPaymentMethod = createSelector(
  selectPaymentState,
  (state) => state.errorAddPaymentMethod
);
